/*********************************************************************************************
 * Initialize the sticky CTA behavior.
 *
 */
function initializeStickyCTA() {
	const classicCTA = document.querySelector("[data-cta]");
	const stickyCTA = document.querySelector("[data-sticky-cta]");

	// Vérifie que les éléments existent
	if (!classicCTA || !stickyCTA) {
		console.error("Les éléments [data-cta] ou [data-sticky-cta] n'existent pas.");
		return;
	}

	function toggleStickyCTA() {
		const rect = classicCTA.getBoundingClientRect();

		// Si le CTA est passé au-dessus du viewport
		if (rect.bottom < 0) {
			stickyCTA.classList.remove("lf-hidden");
		} else {
			stickyCTA.classList.add("lf-hidden");
		}
	}

	window.addEventListener("scroll", toggleStickyCTA, {passive: true});
}

/*********************************************************************************************
 * Initialize the Splide carousel for the reassurance slider.
 *
 */
function initSlideProductReassurance() {
	const splideElemMain = document.querySelector("#slider-reassurance");
	if (splideElemMain) {
		const main = new Splide(splideElemMain, {
			type: "slide",
			rewind: true,
			pagination: true,
			arrows: false,
			autoplay: true,
			interval: 5000,
			perPage: 1,
		});
		main.mount();
	}
}

/*********************************************************************************************
 * Change the quantity value in the input field and update the related prices.
 *
 * @param {number} delta - The change to apply to the current quantity (e.g., +1 or -1).
 * @param {string} inputId - The ID of the input field where the quantity is adjusted.
 */
function changeQtty(delta, inputId) {
	let input = document.getElementById(inputId);
	const plusBtn = document.querySelector(`[data-qtty-plus="${inputId}"]`);

	if (delta === -1 && input.value === "1") {
		return;
	} else {
		var newValue = parseInt(input.value, 10) + parseInt(delta, 10);

		// Vérification si la nouvelle valeur atteint ou dépasse le maximum autorisé
		if (input.max && newValue >= parseInt(input.max, 10)) {
			newValue = parseInt(input.max, 10); // Limiter à la valeur maximale
			plusBtn.setAttribute("disabled", "true"); // Désactiver le bouton "+"
		} else {
			plusBtn.removeAttribute("disabled"); // Réactiver le bouton "+" si on est en dessous de la limite
		}

		// Mise à jour de la valeur de l'input
		input.value = newValue;

		// Mise à jour des prix en fonction de la nouvelle quantité
		updatePrice(newValue);
	}
}

/*********************************************************************************************
 * Update the displayed prices based on the new quantity.
 *
 * @param {number} qtty - The current product quantity used to calculate the prices.
 */
function updatePrice(qtty) {
	var priceAll = document.querySelectorAll("[data-price]");
	var comparePriceAll = document.querySelectorAll("[data-compare-price]");

	// Met à jour les prix normaux
	priceAll.forEach(function (price) {
		var priceValue = parseFloat(price.dataset.price);
		if (!isNaN(priceValue)) {
			price.innerHTML = ((priceValue * qtty) / 100).toFixed(2) + "€";
		} else {
			console.error("Valeur de prix non valide : ", price.dataset.price);
		}
	});

	// Met à jour les prix comparatifs
	comparePriceAll.forEach(function (comparePrice) {
		var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
		if (!isNaN(comparePriceValue)) {
			comparePrice.innerHTML = ((comparePriceValue * qtty) / 100).toFixed(2) + "€";
		} else {
			console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
		}
	});
}

/*********************************************************************************************
 * Class for handling variant selection
 *
 */
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange);
	}

	/*********************************************************************************************
	 * Handle variant change event.
	 *
	 */
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) {
				this.updateImagesVariant();
			} else {
				this.updateMedia();
			}
			this.variantFetch();
		}
	}

	/*********************************************************************************************
	 * Get selected options from the variant checkboxes.
	 *
	 */
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".lf-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	 * Get variant data from the embedded JSON.
	 *
	 * @returns {Object} - The variant data.
	 */
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	 * Get the selected variant based on selected options.
	 *
	 */
	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	/*********************************************************************************************
	 * Update the URL to include the selected variant ID.
	 *
	 */
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	/*********************************************************************************************
	 * Fetch variant data from the server and cache it.
	 *
	 */
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	 * Render variant information in the DOM.
	 *
	 * @param {Document} html - The HTML document containing the variant information.
	 */
	renderVariantInfo(html) {
		this.updateElementOuter("#product_id", html);
		this.updateElementOuter("#product_form_selected_variant_id", html);
		this.updateElementOuter(".lf-product-price", html);
		this.updateMultipleElement(".lf-product-form-variant-value", html);
		this.updateElementOuter(".lf-product-cta", html);
		this.updateElementOuter(".lf-product-gift-card-cta", html);
		this.updateImagesVariant();
	}

	/*********************************************************************************************
	 * Update the inner HTML of an element.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	 * Update the outer HTML of an element.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	 * Update the outer HTML of multiple elements.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateMultipleElement(selector, html) {
		const destination = this.container.querySelectorAll(selector);
		const source = html.querySelectorAll(selector);

		if (source && destination) {
			for (let index = 0; index < source.length; index++) {
				destination[index].outerHTML = source[index].outerHTML;
			}
		}
	}

	/*********************************************************************************************
	 * Update the media carousel to display the featured media of the current variant.
	 *
	 */
	updateMedia() {
		if (this.currentVariant && this.currentVariant.featured_media) {
			var variant_media_id = this.currentVariant.featured_media.id;
			var allMainMedia = document.querySelectorAll(".lf-product-medias .splide__slide");

			allMainMedia.forEach((media, index) => {
				if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
					splideMainInstance.go(index);
				}
			});
		}
	}

	/*********************************************************************************************
	 * Update the visibility of the media sliders for the current variant.
	 *
	 */
	updateImagesVariant() {
		var allMainMedia = document.querySelectorAll(".main-slider-variant");
		allMainMedia.forEach((media) => {
			if (media.dataset.variantid == this.currentVariant.id) {
				media.style.display = "flex";
			} else {
				media.style.display = "none";
			}
		});
		var allThumbnailMedia = document.querySelectorAll(".thumbnail-slider-variant");
		allThumbnailMedia.forEach((media) => {
			if (media.dataset.variantid == this.currentVariant.id) {
				media.style.display = "flex";
			} else {
				media.style.display = "none";
			}
		});
	}
}

/*********************************************************************************************
 * Define the custom element
 *
 */
customElements.define("variant-selector", VariantSelector);

/*********************************************************************************************
/* Description truncate */



/*********************************************************************************************
/* Redirection CTA Buy Now */
// function redirectionBuyNow() {
//   setTimeout(() => {
// 	console.log('checkout')
//     window.location.href = "/checkout";
//   }, "600");
// }

/*********************************************************************************************
/* handle Add to cart */
function handleAddToCart(variantId, buyNow = false, reviews = "") {
  const sellingPlanInput = document.querySelector(".shopify_subscriptions_app_block_label_children input:checked");

  const sellingPlanId = sellingPlanInput?.dataset.sellingPlanId || null;
  const upsellCheckbox = document.querySelector('input[name="upsell-add-to-cart"]:checked');
  const upsellVariantId = upsellCheckbox?.dataset.upsellId;

  addProductToCart(variantId, {openCart: !buyNow, buyNow: buyNow}, sellingPlanId, reviews, upsellVariantId);
}


/*********************************************************************************************
* Add a products pack with selling plan.
	*
	* @param {number} productId - The product ID to add.
	* @param {Object} options - Options for adding the product.
	* @param {number} [options.quantity=1] - The quantity to add.
	* @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
*/
function addProductsWithSellingPlan(productId, {openCart = true, buyNow = false}, reviews = "") {

  const properties = {};

  const inputChecked = document.querySelector(".shopify_subscriptions_app_block_label_children input:checked");

  if (reviews) {
		properties["reviews"] = reviews;
  }

  let items;
  if (inputChecked) {
    const bundleItems = JSON.parse(document.querySelector("[data-bundle-items]").textContent);
    const sellingPlanIndex = inputChecked.dataset.index;

		// Construire un tableau d’items au format Shopify
		items = bundleItems.map((item) => {
			const productData = {
				id: item.variant_id,
				quantity: 1,
				properties: properties
			};

			// Si ce produit a des selling plans et qu’un index est sélectionné
			if (item.selling_plan && sellingPlanIndex !== null) {
				const key = `selling_plan_${sellingPlanIndex}`;
				if (item[key]) {
					productData.selling_plan = item[key];
				}
			}

			return productData;
		});
	} else {
		items = [
			{
				id: productId,
				quantity: 1,
				properties: properties
			},
		];
	}

		// Un seul appel à /cart/add.js avec tous les items
		return lfAPIRequest("POST", "cart/add.js", {
			items,
			sections: cartSectionId(),
		})
			.then(refreshCartFromData)
			.then(addOrRemoveFreeProducts)
			.then((data) => {
				if (buyNow) {
        			//redirection checkout
					setTimeout(() => {
						window.location.href = "/checkout";
						}, 600);
        			return data;
				}
				if (openCart) {
            lfOpenCart();
				}
				return data;
			})
			.catch((error) => {
				// alert(error.message);
				lfOpenCart();
				console.error(error);
			});

}

/*********************************************************************************************
* Dropdown Selling plan group
	*/
function closeSellingPlanDropdown(checkNoSellingPlan) {
  const sellingPlanGroup = document.getElementById("lf-pf-selling-plan-group");

  if (sellingPlanGroup) {
    const checkedInput = checkNoSellingPlan?.querySelector('input[type=radio]:checked');

    if (!checkedInput) {
      // Fermeture du dropdown => Click sur le dropdown que lorsqu'il est déjà ouvert
      if (sellingPlanGroup.classList.contains('active')) {
        sellingPlanGroup.click();
      }

      // Check du premier input du selling plan lors de l'ouverture du dropdown
      sellingPlanGroup.addEventListener("click", () => {
        const firstSellingPlan = sellingPlanGroup.nextElementSibling.querySelector("input[type=radio]");
        firstSellingPlan.checked = true;
      },{ once: true });
    }
  }
}


/*********************************************************************************************
* Affichage formulaire gift card
	*/
function openGiftCardForm() {
	const giftCardForm = document.querySelector(".lf-gift-card-form-container");
	giftCardForm.classList.remove("hidden");
}
function closeGiftCardForm() {
	const giftCardForm = document.querySelector(".lf-gift-card-form-container");
	giftCardForm.classList.add("hidden");
}


/*********************************************************************************************
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	initSlideProductReassurance();
	initializeStickyCTA();
});
